import { useContext, useState } from 'react';
import SectionContext from '../SectionContext';
import HeaderWrapper from './HeaderWrapper';
import SectionNameEditor from './SectionNameEditor';
import SectionName from './SectionName';
import SectionPositionMoving from './SectionPositionMoving';
import SectionActions from './SectionActions';

const SectionHeader = () => {
  const { section } = useContext(SectionContext);
  const [nameEditing, setNameEditing] = useState(false);

  return (
    <HeaderWrapper>
      {nameEditing ? (
        <SectionNameEditor onClose={() => setNameEditing(false)} />
      ) : (
        <>
          <SectionName>{section.name}</SectionName>
          <SectionPositionMoving />
          <SectionActions onNameEdit={() => setNameEditing(true)} />
        </>
      )}
    </HeaderWrapper>
  );
};

export default SectionHeader;
